import { Component, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import {
    trigger,
    state,
    style,
    animate,
    transition
} from "@angular/animations";
import { SplashScreenService } from "../../services/splash-screen.service";

@Component({
    selector: "app-splash-screen",
    standalone: true,
    imports: [CommonModule],
    templateUrl: "./splash-screen.component.html",
    styleUrls: ["./splash-screen.component.scss"],
    animations: [
        trigger("fadeInOut", [
            state("in", style({ opacity: 1 })),
            state("out", style({ opacity: 0 })),
            transition("in => out", animate("800ms ease-out")),
            transition("out => in", animate("800ms ease-in"))
        ]),
        trigger("scaleLogo", [
            state("initial", style({ transform: "scale(0.8)" })),
            state("final", style({ transform: "scale(1)" })),
            transition(
                "initial => final",
                animate("2400ms cubic-bezier(0.4, 0, 0.2, 5)")
            )
        ]),
        trigger("dotsAnimation", [
            state("rotating", style({})),
            state("centering", style({ transform: "scale(0.1)" })),
            transition(
                "rotating => centering",
                animate("1000ms cubic-bezier(0.4, 0, 0.2, 1)")
            )
        ])
    ]
})
export class SplashScreenComponent implements OnInit {
    animationState = "in";
    logoState = "initial";
    dotsState = "rotating";

    constructor(private splashScreenService: SplashScreenService) {}

    ngOnInit() {
        // Start the animation sequence
        setTimeout(() => {
            this.logoState = "final";
        }, 100);

        // Start centering animation before fade out
        setTimeout(() => {
            this.dotsState = "centering";
        }, 2300);

        // Hide splash screen after animation
        setTimeout(() => {
            this.animationState = "out";
            // Hide splash screen after fade out animation completes
            setTimeout(() => {
                this.splashScreenService.hideSplashScreen();
            }, 800);
        }, 2900);
    }
}
